//ナビゲーション
window.onload = function () {
	const nav = document.getElementById("nav-wrapper");
	const hamburger = document.getElementById("js-hamburger");
	const blackBg = document.getElementById("js-black-bg");

	if (!nav || !hamburger || !blackBg) return;

	hamburger.addEventListener("click", function () {
		nav.classList.toggle("open");
	});
	blackBg.addEventListener("click", function () {
		nav.classList.remove("open");
	});
};

const changeCategoryPosts = () => {
	const categoryTabs = document.getElementsByClassName('select-category__item');
	const entries = document.getElementsByClassName('entry--category-latest');

	if (!categoryTabs || categoryTabs.length === 0) return;
	if (!entries || entries.length === 0) return;

	[...categoryTabs].forEach(elem => {
		elem.addEventListener('click', function () {
			[...categoryTabs].forEach(item => {
				item.classList.remove('is-active');
			});
			this.classList.add('is-active');

			const target = this.dataset.cat;

			const targetElem = document.querySelector(`[data-target="${target}"]`);

			[...entries].forEach(item => {
				item.classList.remove('is-active');
			})

			if (targetElem) {
				targetElem.classList.add('is-active');
			}
		})
	})
}
changeCategoryPosts();
